import React, { memo } from "react";
import { HStack, Text } from "@chakra-ui/react";
import colors from "app/colors";

import { ClockArrowIcon } from "modules/icons";
import { DistributionGroupFragment } from "gql/graphql";

interface IProps {
  distributionGroup: DistributionGroupFragment;
}

const AdminDistributionGroupHistoricalAccess = ({
  distributionGroup,
}: IProps) => {
  if (distributionGroup.isHistoricalAccess) {
    return (
      <HStack w="full" spacing={1}>
        <ClockArrowIcon boxSize={4} fill={colors.gray50} />
        <Text
          fontSize={13}
          fontWeight={700}
          color={colors.gray50}
          noOfLines={1}
        >
          Historical Access ON:
        </Text>
        <Text
          fontSize={13}
          fontWeight={500}
          color={colors.gray50}
          noOfLines={1}
        >
          New members added to ALL existing threads
        </Text>
      </HStack>
    );
  }

  return (
    <HStack w="full" spacing={1}>
      <ClockArrowIcon boxSize={4} fill={colors.gray50} />
      <Text fontSize={13} fontWeight={700} color={colors.gray50} noOfLines={1}>
        Historical Access OFF:
      </Text>
      <Text fontSize={13} fontWeight={500} color={colors.gray50} noOfLines={1}>
        New members not added to existing threads
      </Text>
    </HStack>
  );
};

export default memo(AdminDistributionGroupHistoricalAccess);
